// extracted by mini-css-extract-plugin
module.exports = {"list":"_025a50318d--list--FGucY","item-wrapper":"_025a50318d--item-wrapper--FP0iM","focused":"_025a50318d--focused--wabHu"};